import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";
import moment from "moment";
import InputMask from 'react-input-mask';

//ASSETS
import ic_up_arrow from "ASSETS/Images/ic_uparrow.svg";
import ic_down_arrow from "ASSETS/Images/ic_down_arrow.svg";

//UTILITY
import { REGEX } from "UTILS/Constants";
import { isTimeValid } from "UTILS/regexValidations";

//Stylsheet
import "./TimePicker.less";

const minStep = 5;

class TimePicker extends Component{
  constructor(props){
    super(props)
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    let time = moment().format('HH:mm').split(/:| /);
    this.state = {
      hours: time[0],
      minutes: time[1],
      chooseTime: false,
      time
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      this.resetClock()
    }
  }
 
  resetClock = () =>{
    let time = this.props.value ? 
      this.props.value.split(/:| /) :
      moment().format('HH:mm').split(/:| /);
    this.setState({
      hours: ("0" + time[0]).slice(-2),
      minutes: ("0" + time[1]).slice(-2),
      time
    })
  }

  /**
   * close timepicker if clicked on outside of element
   */
  handleClickOutside = (event) => {
    if (event.clientX + 15 <= window.innerWidth && this.wrapperRef && !this.wrapperRef.current?.contains(event.target) && this.state.chooseTime) {
      this.toggleTimePicker()
    }
  }

  incrementHour=()=>{
    let hours = parseInt(this.state.hours);
    hours += 1;

    /* Hour sets to 0 if it is greater than 23 */
    if(hours > 23) {
      hours = "00";
    }
    if( hours.toString().length === 1 ) {
      hours = "0" + hours;
    }
    this.setState({
      hours
    },()=>this.setClock());
  }

  incrementMinute = () => {
    let minutes = parseInt(this.state.minutes);
    if (minutes % minStep === 0) {
      minutes += minStep;
    } else {
      minutes += minStep - minutes % minStep;
    }

    if(minutes > 59) {
      minutes = 0;
    }
    if( minutes.toString().length === 1 ) {
      minutes = "0" + minutes;
    }
    this.setState({
      minutes
    },()=>this.setClock());
  }

  decrementHour = () => {
    let hours = parseInt(this.state.hours);
    hours -= 1;

    // owthereise available hours are 0 to 23    
    if(hours < 0 ) {
      hours = 23;
    }
    if( hours.toString().length === 1 ) {
      hours = "0" + hours;
    }
    this.setState({
      hours
    },()=>this.setClock());
  }

  decrementMinute = () => {
    let minutes = parseInt(this.state.minutes);
    if (minutes % minStep === 0){
      minutes -= minStep;
    } else {
      minutes -= minutes % minStep;
    }

    if(minutes < 0 ) {
      minutes += 60;
    }

    if( minutes.toString().length === 1 ) {
      minutes = "0" + minutes;
    }
    this.setState({
      minutes
    },()=>this.setClock());
  }

  setTime = () => {
    this.props.setTime(this.state.hours + ":" + this.state.minutes );
    this.toggleTimePicker();
  }

  toggleTimePicker = () => {
    this.setState({
      chooseTime : !this.state.chooseTime
    });
    this.resetClock();
  }

  changeTime = (event) => {
    let time= event.target.value.split(/:| /);
    ((!time[0].includes('_') && parseInt(time[0]) < 24) || time[0].includes('_')) &&
      this.setState({
        time: event.target.value,
        hours: time[0].includes('_') ? this.state.hours : time[0],
        minutes: time[1].includes('_') ? this.state.minutes : time[1],
        timeError: ""
      }) 

  }

  setClock = () => {
    this.setState({
      time: this.state.hours+":"+this.state.minutes
    })
  }

  render() {
    return(
      !this.state.chooseTime ?
        <div className="timePickerWrapper">
          <input
            value={this.props.value} 
            placeholder={this.props.placeholder}
            onFocus={this.toggleTimePicker}
            className={this.props.value ? 
              "w-100 border formControlName form-control text-center":
              "w-100 border formControlName form-control"}
            readOnly/>
        </div>
        :
        <div ref={this.wrapperRef} className="timePickerWrapper">
          <InputMask 
            className="w-100 border formControlName form-control text-center"
            mask="Hh:Mm"
            value={this.state.time}
            formatChars={REGEX.TIME_PATTERN} 
            alwaysShowMask
            autoFocus={true}
            onChange={this.changeTime}
            onKeyPress={this.handleKeyPress}/>
          <div className="timepicker container position-absolute card card-body">
            <div className="d-flex justify-content-center">
              <div className="col-6 d-flex flex-column">
                <span className="arrow d-flex justify-content-center" onClick={this.incrementHour}>
                  <img src={ic_up_arrow} />
                </span>
                <span className="d-flex justify-content-center">{this.state.hours}</span>
                <span className="arrow d-flex justify-content-center" onClick={this.decrementHour}>
                  <img src={ic_down_arrow} />
                </span>
              </div>
              <div className="col-6 d-flex flex-column">
                <span className="arrow d-flex justify-content-center" onClick={this.incrementMinute}>
                  <img src={ic_up_arrow} />
                </span>
                <span className="d-flex justify-content-center">{this.state.minutes}</span>
                <span className="arrow d-flex justify-content-center" onClick={this.decrementMinute}>
                  <img src={ic_down_arrow} />
                </span>
              </div>
            </div>  
            <div className="row pt-2">
              <div className="col">
                <button className="btn w-100 rounded-pill setTimeBtn" onClick={this.setTime}>
                  {getMessage("SET_TIME")}
                </button> 
              </div>
            </div> 
          </div>
        </div>
        
    )
  }
}

export default TimePicker;